<template>
  <div ref="formcard"></div>
  <AuthComponent></AuthComponent>
  <v-card
    class="py-4 w-100 align-center"
    :class="$vuetify.display.mobile ? 'px-0' : 'px6'"
  >
    <v-card-text>
      <v-divider></v-divider>
      <FormsComponent></FormsComponent>
    </v-card-text>
  </v-card>
</template>

<script>
import { defineComponent } from 'vue'
import FormsComponent from '../components/FormsComponent.vue'

export default defineComponent({
  name: 'FormPage',
  components: {
    FormsComponent,
  },
  data() {
    return {
      selectedTask: null,
    }
  },
})
</script>
